"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
/**
 * Enums
 */
var DocumentType;
(function (DocumentType) {
    DocumentType["Script"] = "Script";
    DocumentType["Storyboard"] = "Storyboard";
    DocumentType["ShootingSchedule"] = "Shoot Schedule";
    DocumentType["MediaPlan"] = "Media Plan";
    DocumentType["Contract"] = "Contract";
    DocumentType["License"] = "License";
    DocumentType["Generic"] = "Generic";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
//# sourceMappingURL=document-types.js.map